import { Chip, Tooltip } from '@mui/material';
import { Drone } from '../../types/drone';
import { useNow } from '../../hooks/useNow';
import { credentialsAttention, credentialsAttentionLabel, renewCommands } from '../../utils/credentials';

/**
 * A drone whose credentials expire within 7 days, or no longer work (#777,
 * C16), marked on the drone itself in the Fleet gallery and its report card.
 * The tooltip names the command that renews it; the browser never holds a
 * token.
 */
export const CredentialsChip: React.FC<{ drone: Drone }> = ({ drone }) => {
  const now = useNow(60_000);
  const attention = credentialsAttention(drone, now);
  if (!attention) return null;
  return (
    <Tooltip title={`Renew it from a terminal: ${renewCommands(drone).join(' — or, in the cluster, ')}`}>
      <Chip
        label={credentialsAttentionLabel(drone, attention, now)}
        color={attention === 'expiring' ? 'warning' : 'error'}
        size="small"
      />
    </Tooltip>
  );
};
